/* Maison Fianchetto : option « gravure » (snippets/mf-gravure.liquid), rév. 27.
   - Fiche produit : interrupteur -> panneau qui s'ouvre sous l'encadré (champ 30 caractères + aperçu).
     Le texte peut être écrit plus tard ; il est exigé seulement au moment d'ajouter au panier.
     Le « i » ouvre une bulle d'explication (et les exemples choisis dans les réglages du thème).
   - Ajout au panier (assets/product-form.js appelle window.mfGravure.prepare) : l'échiquier et le
     produit « Gravure personnalisée » partent ensemble, reliés par la propriété cachée _gravure.
     Deux ajouts avec deux textes différents -> deux lignes d'échiquier, chacune avec sa gravure.
   - Panier : une gravure dont l'échiquier a été retiré est retirée ; la quantité de gravure suit
     celle de l'échiquier ; si la gravure est retirée, le texte est enlevé de l'échiquier. */
(() => {
  const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

  if (!customElements.get('mf-gravure')) {
    customElements.define(
      'mf-gravure',
      class MfGravure extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.max = parseInt(this.dataset.max, 10) || 30;
          this.form = this.closest('form');
          this.toggle = this.querySelector('.mf-gravure__toggle');
          this.panel = this.querySelector('.mf-gravure__panel');
          this.input = this.querySelector('.mf-gravure__input');
          this.count = this.querySelector('.mf-gravure__count');
          this.preview = this.querySelector('.mf-gravure__preview-text');
          this.error = this.querySelector('.mf-gravure__error');
          this.info = this.querySelector('.mf-gravure__info');
          this.pop = this.querySelector('.mf-gravure__pop');

          this.toggle.addEventListener('change', () => this.setOpen(this.toggle.checked, true));
          this.input.addEventListener('input', () => this.render());
          this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') e.preventDefault(); // Entrée ne doit pas ajouter au panier par surprise
          });
          this.info.addEventListener('click', (e) => {
            e.preventDefault();
            this.setPop(this.pop.hidden);
          });
          document.addEventListener('click', (e) => {
            if (!this.pop.hidden && !this.pop.contains(e.target) && !this.info.contains(e.target)) this.setPop(false);
          });
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !this.pop.hidden) {
              this.setPop(false);
              this.info.focus();
            }
          });
          this.render();
          // 21/10 (audit) : la réassurance « Retours 14 jours » devient « Article personnalisé » quand la gravure est cochée
          this.syncTrust();
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.syncTrust(), 0));
            // 29/10 : option cachée (et décochée) sur les variantes non gravables (data-sans-gravure, cf. mf-gravure.liquid)
            subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.syncVariant(), 0));
          }
        }

        syncVariant() {
          const id = this.form && this.form.querySelector('input[name="id"]');
          const sans = (this.dataset.sansGravure || '').split(',').filter(Boolean);
          const off = !!(id && sans.includes(String(id.value)));
          this.style.display = off ? 'none' : '';
          if (off && this.toggle.checked) {
            this.toggle.checked = false;
            this.setOpen(false, false);
            this.syncTrust();
          }
        }

        syncTrust() {
          const on = this.toggle.checked;
          document.querySelectorAll('[data-mf-trust="retours"]').forEach((li) => { li.style.display = on ? 'none' : ''; });
          document.querySelectorAll('[data-mf-trust="perso"]').forEach((li) => { li.style.display = on ? '' : 'none'; });
        }

        setPop(open) {
          this.pop.hidden = !open;
          this.info.setAttribute('aria-expanded', String(open));
        }

        setOpen(open, focus) {
          this.classList.toggle('is-active', open);
          this.syncTrust();
          this.panel.hidden = !open;
          if (!open) this.error.hidden = true;
          if (open && focus) setTimeout(() => this.input.focus({ preventScroll: true }), 60);
        }

        text() {
          return this.input.value.trim();
        }

        quantity() {
          const q = this.form && this.form.elements.quantity;
          return Math.max(1, parseInt(q && q.value, 10) || 1);
        }

        active() {
          return this.toggle.checked;
        }

        // Textes à graver, un par échiquier ajouté
        perUnit() {
          const t = this.text();
          return t ? Array(this.quantity()).fill(t) : null;
        }

        open() {
          this.toggle.checked = true;
          this.setOpen(true, false);
          this.error.hidden = false;
          this.input.focus();
          this.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }

        render() {
          const t = this.input.value;
          this.count.textContent = t.length + ' / ' + this.max;
          if (this.preview) {
            this.preview.textContent = t.trim() || 'Votre texte ici';
            this.preview.classList.toggle('is-empty', !t.trim());
          }
          if (t.trim()) this.error.hidden = true;
        }
      }
    );
  }

  /* ---------- Boîte de rangement sur la fiche (snippets/mf-boite-fiche.liquid, 18/10) ----------
     L'encadré suit la variante choisie (chaque taille de jeu a sa boîte) ; activé, la boîte part avec le jeu. */
  if (!customElements.get('mf-boite')) {
    customElements.define(
      'mf-boite',
      class MfBoite extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          try {
            this.map = JSON.parse(this.dataset.map || '{}');
          } catch {
            this.map = {};
          }
          this.form = this.closest('form');
          this.toggle = this.querySelector('.mf-boite__toggle');
          this.info = this.querySelector('.mf-gravure__info');
          this.pop = this.querySelector('.mf-gravure__pop');
          this.toggle.addEventListener('change', () => this.classList.toggle('is-active', this.toggle.checked));
          this.info.addEventListener('click', (e) => {
            e.preventDefault();
            this.setPop(this.pop.hidden);
          });
          document.addEventListener('click', (e) => {
            if (!this.pop.hidden && !this.pop.contains(e.target) && !this.info.contains(e.target)) this.setPop(false);
          });
          const id = this.form && this.form.querySelector('input[name="id"]');
          if (id) new MutationObserver(() => this.update()).observe(id, { attributes: true, attributeFilter: ['value'] });
          this.update();
        }

        setPop(open) {
          this.pop.hidden = !open;
          this.info.setAttribute('aria-expanded', String(open));
        }

        box() {
          const id = this.form && this.form.querySelector('input[name="id"]');
          return id ? this.map[id.value] : null;
        }

        update() {
          const b = this.box();
          this.hidden = !b;
          if (!b) return;
          this.querySelector('[data-mf-boite-price]').textContent = b.price;
          const fit = this.querySelector('[data-mf-boite-fit]');
          if (fit) fit.textContent = [b.dim, b.pour && b.pour.replace(/^Roi/, 'pour un roi')].filter(Boolean).join(' · ');
        }

        // variante de boîte à ajouter, ou null
        wanted() {
          const b = this.box();
          return b && this.toggle.checked ? b.id : null;
        }
      }
    );
  }

  /* ---------- Ajout au panier ---------- */
  const variantTitle = (form) => {
    const info = form.closest('product-info') || document;
    const picked = [...info.querySelectorAll('variant-selects input:checked, variant-selects select')].map((el) =>
      el.tagName === 'SELECT' ? el.selectedOptions[0] && el.selectedOptions[0].value : el.value
    );
    return picked.filter(Boolean).join(' / ');
  };

  // Emballage cadeau (snippets/mf-cadeau.liquid) : ajouté avec l'article, en une seule fois par commande (voir sync)
  const addCadeau = (form, formData) => {
    const box = form && form.querySelector('mf-cadeau');
    const on = box && box.querySelector('.mf-cadeau__toggle').checked;
    if (!on) return;
    addExtra(formData, box.dataset.variantId);
  };

  // ajoute un article (emballage, boîte…) à l'envoi du formulaire, en passant au format items[] si besoin
  const addExtra = (formData, variantId) => {
    if (formData.has('id')) {
      // pas de gravure : passage au format items[] pour ajouter deux articles d'un coup
      const props = [];
      for (const [k, v] of formData.entries()) if (k.startsWith('properties[')) props.push([k.slice(11, -1), v]);
      const id = formData.get('id');
      const qty = formData.get('quantity') || 1;
      ['id', 'quantity'].forEach((k) => formData.delete(k));
      props.forEach(([k]) => formData.delete(`properties[${k}]`));
      formData.append('items[0][id]', id);
      formData.append('items[0][quantity]', qty);
      props.forEach(([k, v]) => formData.append(`items[0][properties][${k}]`, v));
    }
    let i = 0;
    while (formData.has(`items[${i}][id]`)) i += 1;
    formData.append(`items[${i}][id]`, variantId);
    formData.append(`items[${i}][quantity]`, 1);
  };

  const prepare = (productForm, formData) => {
    const form = productForm.form;
    const ok = prepareGravure(form, formData);
    // 18/10 : l'emballage cadeau ne se choisit plus sur la fiche mais dans le panier (voir plus bas), sauf ancien encadré
    if (ok && form && form.querySelector('mf-cadeau')) addCadeau(form, formData);
    const boite = form && form.querySelector('mf-boite');
    const boxId = ok && boite && boite.wanted && boite.wanted();
    if (boxId) addExtra(formData, boxId);
    return ok;
  };

  // Retourne false si l'ajout doit être bloqué (textes à compléter)
  const prepareGravure = (form, formData) => {
    const el = form && form.querySelector('mf-gravure');
    if (!el || !el.active()) return true;
    const per = el.perUnit();
    if (!per) {
      el.open();
      return false;
    }
    const id = formData.get('id');
    const props = [];
    for (const [k, v] of formData.entries()) if (k.startsWith('properties[')) props.push([k.slice(11, -1), v]);
    const opts = variantTitle(form);
    const pour = el.dataset.productTitle + (opts ? ` – ${opts}` : '');

    // Regroupement : un texte commun = une ligne de N ; sinon une ligne par texte
    const groups = [];
    per.forEach((t) => {
      const g = groups.find((x) => x.text === t);
      if (g) g.qty += 1;
      else groups.push({ text: t, qty: 1 });
    });

    ['id', 'quantity'].forEach((k) => formData.delete(k));
    props.forEach(([k]) => formData.delete(`properties[${k}]`));
    let i = 0;
    for (const g of groups) {
      const link = uid();
      formData.append(`items[${i}][id]`, id);
      formData.append(`items[${i}][quantity]`, g.qty);
      props.forEach(([k, v]) => formData.append(`items[${i}][properties][${k}]`, v));
      formData.append(`items[${i}][properties][Gravure]`, g.text);
      formData.append(`items[${i}][properties][_gravure]`, link);
      i += 1;
      formData.append(`items[${i}][id]`, el.dataset.variantId);
      formData.append(`items[${i}][quantity]`, g.qty);
      formData.append(`items[${i}][properties][Texte]`, g.text);
      formData.append(`items[${i}][properties][Pour]`, pour);
      formData.append(`items[${i}][properties][_gravure]`, link);
      i += 1;
    }
    return true;
  };

  /* ---------- Cohérence du panier ---------- */
  const GRAVURE = 'gravure-personnalisee';
  const CADEAU = 'emballage-cadeau';
  const isKeyring = (it) => typeof it.handle === 'string' && it.handle.startsWith('porte-cles-');
  let syncing = false;

  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());

  // 20/10 soir (cliente : « il ne faut pas que la gravure reste seule dans le panier ») : lecture du panier avec un repli.
  // Dans l'aperçu du thème (127.0.0.1:9292), GET /cart.js répond 401 : la vérification échouait sans rien dire et la
  // gravure restait seule. Une mise à jour vide (POST /cart/update.js) renvoie le même panier, sans rien changer.
  const readCart = async () => {
    try {
      const r = await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      if (r.ok) return await r.json();
    } catch (e) {
      /* repli ci-dessous */
    }
    return post(`${window.routes.cart_update_url}.js`, { updates: {} });
  };
  window.mfReadCart = readCart;

  const refresh = async () => {
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return;
    }
    const drawerItems = document.querySelector('cart-drawer-items');
    if (drawerItems && drawerItems.onCartUpdate) await drawerItems.onCartUpdate();
    try {
      const s = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}?sections=cart-icon-bubble`).then((r) => r.json());
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && s['cart-icon-bubble']) {
        bubble.innerHTML = new DOMParser()
          .parseFromString(s['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section').innerHTML;
      }
    } catch (e) {
      /* la pastille se mettra à jour au prochain chargement */
    }
  };

  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      const cart = await readCart();
      const boards = new Map();
      const engr = new Map();
      for (const it of cart.items) {
        const link = it.properties && it.properties._gravure;
        if (!link) continue;
        (it.handle === GRAVURE ? engr : boards).set(link, it);
      }
      const updates = {};
      const strip = [];
      // gravure sans lien vers un échiquier (ajoutée seule) : retirée aussi
      cart.items.forEach((it) => {
        if (it.handle === GRAVURE && !(it.properties && it.properties._gravure)) updates[it.key] = 0;
      });
      for (const [link, g] of engr) {
        const b = boards.get(link);
        if (!b) updates[g.key] = 0;
        else if (b.quantity !== g.quantity) updates[g.key] = b.quantity;
      }
      for (const [link, b] of boards) if (!engr.has(link)) strip.push(b);
      // emballage cadeau (18/10) : un emballage par article, relié par _cadeau ; sa quantité suit celle de l'article,
      // il part si l'article est retiré. Un ancien emballage sans lien : un seul par commande, s'il reste un article.
      // porte-clés (19/10) : jamais seuls ; s'il ne reste que des porte-clés (ou des services), on les retire
      const keyrings = cart.items.filter(isKeyring);
      const mains = cart.items.filter((it) => it.handle !== CADEAU && it.handle !== GRAVURE && !isKeyring(it));
      if (keyrings.length && !mains.length) keyrings.forEach((k) => (updates[k.key] = 0));
      const gifts = cart.items.filter((it) => it.handle === CADEAU);
      const others = cart.items.filter((it) => it.handle !== CADEAU && it.handle !== GRAVURE);
      let loose = 0;
      gifts.forEach((g) => {
        const link = g.properties && g.properties._cadeau;
        let want;
        if (link) {
          const owner = others.find((it) => it.properties && it.properties._cadeau === link);
          want = owner ? owner.quantity : 0;
        } else {
          want = others.length && loose === 0 ? 1 : 0;
          loose += 1;
        }
        if (g.quantity !== want) updates[g.key] = want;
      });
      if (!Object.keys(updates).length && !strip.length) return;
      if (Object.keys(updates).length) await post(`${window.routes.cart_update_url}.js`, { updates });
      for (const b of strip) {
        // Shopify ignore un objet de propriétés vide : on vide les valeurs (Dawn n'affiche pas les propriétés vides)
        const props = { ...b.properties, Gravure: '', _gravure: '' };
        await post(`${window.routes.cart_change_url}.js`, { id: b.key, quantity: b.quantity, properties: props });
      }
      await refresh();
    } catch (e) {
      console.error('Gravure : synchronisation du panier impossible', e);
    } finally {
      syncing = false;
    }
  };

  window.mfGravure = { prepare, sync };

  /* ---------- Panier « façon McDo » (18/10, snippets/mf-cart-item-options.liquid) ---------- */
  const cartJs = readCart;
  const busy = (el, on) => {
    const row = el.closest('.mf-cart-opt');
    if (row) row.classList.toggle('is-busy', on);
  };

  // phase de capture : la case ne doit pas atteindre cart-items de Dawn, qui la prendrait pour une quantité
  // (message « uniquement par incréments de »)
  document.addEventListener('change', async (e) => {
    const box = e.target.closest('[data-mf-cadeau]');
    if (!box) return;
    e.stopPropagation();
    busy(box, true);
    box.closest('.mf-cart-opt').classList.toggle('is-on', box.checked);
    syncing = true;
    try {
      const cart = await cartJs();
      const item = cart.items.find((it) => it.key === box.dataset.key);
      if (!item) return;
      if (box.checked) {
        const link = uid();
        // l'article garde ses propriétés (gravure…) et reçoit le lien vers son emballage
        await post(`${window.routes.cart_change_url}.js`, { id: item.key, quantity: item.quantity, properties: { ...item.properties, _cadeau: link } });
        await post(`${window.routes.cart_add_url}.js`, {
          items: [{ id: Number(box.dataset.variant), quantity: item.quantity, properties: { Pour: box.dataset.title, _cadeau: link } }],
        });
      } else {
        const link = item.properties && item.properties._cadeau;
        const wraps = cart.items.filter((it) => it.handle === CADEAU && it.properties && it.properties._cadeau === link);
        if (wraps.length) {
          const updates = {};
          wraps.forEach((w) => (updates[w.key] = 0));
          await post(`${window.routes.cart_update_url}.js`, { updates });
        }
        await post(`${window.routes.cart_change_url}.js`, { id: item.key, quantity: item.quantity, properties: { ...item.properties, _cadeau: '' } });
      }
    } catch (err) {
      console.error('Emballage cadeau : mise à jour impossible', err);
    } finally {
      syncing = false;
      await refresh();
    }
  }, true);

  // petit « i » de l'emballage : ouvre la photo et la description, sans cocher la case
  document.addEventListener('click', (e) => {
    const info = e.target.closest('[data-mf-info]');
    if (!info) return;
    e.preventDefault();
    e.stopPropagation();
    // la page panier rend le bloc deux fois (ordinateur / téléphone) : on prend le panneau du même bloc
    const opts = info.closest('.mf-cart-opts');
    const panel = (opts && opts.querySelector('.mf-cart-wrapinfo')) || document.getElementById(info.getAttribute('aria-controls'));
    if (!panel) return;
    const open = panel.hidden;
    panel.hidden = !open;
    info.setAttribute('aria-expanded', String(open));
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mf-addbox]');
    if (!btn) return;
    e.preventDefault();
    busy(btn, true);
    btn.disabled = true;
    try {
      await post(`${window.routes.cart_add_url}.js`, { items: [{ id: Number(btn.dataset.mfAddbox), quantity: 1 }] });
    } catch (err) {
      console.error('Boîte de rangement : ajout impossible', err);
    }
    await refresh();
  });

  const subscribeWhenReady = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
        // après un ajout depuis la fiche : seul l'emballage cadeau peut demander une correction (doublon)
        setTimeout(sync, e && e.source === 'product-form' ? 400 : 50);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeWhenReady);
  else subscribeWhenReady();
  if (document.getElementById('main-cart-items')) sync();
  // une gravure déjà seule dans le tiroir (ligne non rattachée à son échiquier) : nettoyée dès le chargement de la page
  else if (document.querySelector('cart-drawer .mf-cart-gravure:not(.mf-cart-gravure--attached)')) sync();
})();

/* ---------- Porte-clés (19/10) : bouton « Ajouter au panier » actif seulement si le panier contient déjà un article ----------
   La règle est aussi appliquée dans le panier (sync : porte-clés retirés s'ils restent seuls). */
(() => {
  const note = document.querySelector('[data-mf-keyring]');
  if (!note) return;
  const form = note.closest('form') || document.querySelector('product-form form');
  const btn = form && form.querySelector('[name="add"]');
  if (!btn) return;
  const label = btn.querySelector('span');
  const original = label ? label.textContent : '';
  const check = async () => {
    try {
      const cart = window.mfReadCart
        ? await window.mfReadCart()
        : await fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const ok = cart.items.some((it) => !['emballage-cadeau', 'gravure-personnalisee'].includes(it.handle) && !it.handle.startsWith('porte-cles-'));
      btn.disabled = !ok;
      if (label) label.textContent = ok ? original : 'Ajoutez d’abord un échiquier';
      note.classList.toggle('is-blocking', !ok);
    } catch (e) {
      /* en cas d'erreur, le panier fera la vérification */
    }
  };
  check();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(check, 300));
})();

/* 20/10 (accord cliente) : délai d'expédition au-dessus du bouton de paiement (snippets/mf-cart-ship.liquid).
   Heure de Paris ; avant l'heure limite un jour ouvré : expédié aujourd'hui, sinon le jour ouvré suivant au matin.
   Défini ici (fichier chargé sur toutes les pages) pour fonctionner aussi quand le tiroir du panier est réaffiché. */
(() => {
  if (customElements.get('mf-ship-line')) return;
  /* 21/10 (audit final, accord cliente « fais gaffe que ce soit pas faux ») : jours fériés de France ET de Pologne
     (le fournisseur expédie de Pologne, la commande lui est transmise de France) : un jour férié dans l'un des deux pays
     n'est pas un jour ouvré. Calculés pour toute année (Pâques par l'algorithme grégorien), aucune liste à tenir à jour. */
  const mfFerie = window.mfFerie || (window.mfFerie = (() => {
    const cache = {};
    const key = (d) => d.getMonth() + 1 + '-' + d.getDate();
    const build = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const paques = new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
      const plus = (n) => { const x = new Date(paques); x.setDate(x.getDate() + n); return key(x); };
      // France : 1/1, lundi de Pâques, 1/5, 8/5, Ascension, lundi de Pentecôte, 14/7, 15/8, 1/11, 11/11, 25/12
      // Pologne : 1/1, 6/1, lundi de Pâques, 1/5, 3/5, Fête-Dieu, 15/8, 1/11, 11/11, 24/12 (depuis 2025), 25/12, 26/12
      return new Set(['1-1', '1-6', '5-1', '5-3', '5-8', '7-14', '8-15', '11-1', '11-11', '12-24', '12-25', '12-26', plus(1), plus(39), plus(50), plus(60)]);
    };
    return (d) => (cache[d.getFullYear()] ||= build(d.getFullYear())).has(key(d));
  })());
  const workday = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !mfFerie(d);
  customElements.define(
    'mf-ship-line',
    class extends HTMLElement {
      connectedCallback() {
        const el = this.querySelector('[data-ship-line]');
        if (!el) return;
        const cutoff = parseInt(this.dataset.cutoff, 10) || 13;
        const p = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
          .formatToParts(new Date())
          .forEach((x) => { p[x.type] = x.value; });
        const today = new Date(+p.year, +p.month - 1, +p.day);
        const sameDay = workday(today) && +p.hour % 24 < cutoff;
        if (sameDay) {
          el.textContent = `Commandez avant ${cutoff} h : expédié aujourd’hui`;
          return;
        }
        const ship = new Date(today);
        do { ship.setDate(ship.getDate() + 1); } while (!workday(ship));
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const word = ship.getTime() === tomorrow.getTime() ? 'demain' : ship.toLocaleDateString('fr-FR', { weekday: 'long' });
        el.textContent = `Commandez maintenant : expédié ${word}`;
      }
    }
  );
})();
